exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".validate-image{\r\n    width: 200px;\r\n    border-radius: 100%;\r\n    height: 200px;\r\n}\r\n.heading-title{\r\n    margin-top: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/auth-actions/auth-actions.component.css
// module id = ../../../../../src/app/auth/auth-actions/auth-actions.component.css
// module chunks = main